import { useTranslation } from 'react-i18next';
import { scrollToSection } from '../page';

export default function ProductsHero() {
  const { t } = useTranslation();

  return (
    <section className="relative pt-20 pb-8 bg-[#0d1f3c] overflow-hidden">
      {/* Background gradient blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] rounded-full bg-[#1B3F7A] blur-3xl -translate-x-1/2 -translate-y-1/2 opacity-20" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#2456A4] blur-3xl translate-x-1/4 translate-y-1/4 opacity-15" />
      </div>

      {/* Background decorative image */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <img
          src="https://storage.readdy-site.link/project_files/f2e80cb9-6e9d-476e-b707-141660fae558/de9bd142-9a70-4fe8-91f2-7b542b1c6624_unnamed.png?v=1948ddcb4e420098d230368c3eeeb1df"
          alt=""
          className="absolute right-[200px] top-1/2 -translate-y-1/2 w-[420px] max-h-full object-contain opacity-[0.45]"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full border border-white/20 bg-white/10 backdrop-blur-sm mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#7eb8f7] animate-pulse inline-block" />
            <span className="text-white/90 text-xs tracking-widest uppercase font-medium">
              {t('products.badge')}
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white leading-tight mb-4">
            {t('products.hero.title1')}<br />
            <span className="text-[#7eb8f7]">{t('products.hero.title2')}</span>
          </h1>
          <p className="text-white/70 text-base leading-relaxed mb-6 max-w-xl">
            {t('products.hero.desc')}
          </p>

          {/* Three series badges */}
          <div className="flex flex-wrap gap-3 mb-7">
            {[
              { label: t('products.series.mercury.name'), icon: 'ri-contrast-drop-2-line', color: 'bg-amber-400/20 text-amber-300 border-amber-400/30' },
              { label: t('products.series.heating.name'), icon: 'ri-temp-hot-line', color: 'bg-orange-400/20 text-orange-300 border-orange-400/30' },
              { label: t('products.series.uv.name'), icon: 'ri-sun-line', color: 'bg-violet-400/20 text-violet-300 border-violet-400/30' },
            ].map(badge => (
              <div key={badge.label} className={`flex items-center gap-2 px-4 py-2 rounded-full border ${badge.color} text-sm font-semibold`}>
                <i className={`${badge.icon} text-base`} />
                {badge.label}
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => scrollToSection('cta')}
              className="px-6 py-2.5 bg-white text-[#1B3F7A] font-semibold rounded-full hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              {t('products.cta.btn1')}
            </button>
            <button
              onClick={() => scrollToSection('series')}
              className="flex items-center gap-2 px-6 py-2.5 border border-white/40 text-white font-semibold rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              {t('products.hero.explore')}
              <i className="ri-arrow-down-line text-sm" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
